import { FactoryProvider, Optional } from '@angular/core';
import { ApiConfig } from '@mri-platform/shared/core';
import { OAuthModuleConfig } from '@mri/angular-wfe-proxy-oidc';
import { AUTHENTICATED_API_URL } from './authenticated-api-url.token';

const OAuthModuleConfigFactory = (apiConfig: ApiConfig, securedApiUrls: string[] | null): OAuthModuleConfig => {
  const additionalUrls = securedApiUrls ?? [];
  return {
    resourceServer: {
      allowedUrls: [apiConfig.baseUrl, ...additionalUrls],
      sendAccessToken: true,
      sendClientId: true
    }
  };
};

export const OAuthModuleConfigProvider: FactoryProvider = {
  provide: OAuthModuleConfig,
  useFactory: OAuthModuleConfigFactory,
  deps: [ApiConfig, [new Optional(), AUTHENTICATED_API_URL]]
};
